export default defineNuxtPlugin(() => {
	return {
		provide: {
			goto: (to: string) => (window.location.href = to),
			navigate: (to: string) => navigateTo(to),
		},
	}
})
